import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import db from '@/firebase/init'
import Index from '@/components/frontend/Index'
import AddMumblCard from '@/components/backend/AddMumblCard'
import EditMumblCard from '@/components/backend/EditMumblCard'
import Signup from '@/components/auth/Signup'
import Login from '@/components/auth/Login'

Vue.use(Router)

const router = new Router({
  // remove # on deployed version in url
  mode: 'history',
  routes: [
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/add-mumblcard',
        name: 'AddMumblCard',
        component: AddMumblCard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/edit-mumblcard',
        name: 'EditMumblCard',
        component: EditMumblCard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/signup',
        name: 'Signup',
        component: Signup
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
    // check to see if route requires auth
    if (to.matched.some(rec => rec.meta.requiresAuth)) {
        // check auth state of user
        let user = firebase.auth().currentUser

        // if user is signed in pass the route guard and get access to requested route via function next
        if (user) {
            next()
        } else {
            // if user is not signed in redirect to login route
            next({ name: 'Login' })
        }
    }
    // if route doesn't require auth go to requested route
    else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js